module.exports = __webpack_public_path__ + "static/media/lunch.6e2dace9.svg";